<template>
    <div class="p-4 bg-white shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
            <span class="text-2xl mr-2">⏸️</span>
            <span>Students on hold</span>
        </h2>

        <div v-if="hasData">
            <apexchart type="bar" height="400" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">⚠️</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentOnHold",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        distributed: true,
                        dataLabels: {
                            position: 'center',
                        }
                    }
                },
                colors: [
                    "#01B8AA", "#374649", "#FD625E", "#F2C80F", "#5F6B6D",
                    "#8AD4EB", "#FE9666", "#A66999", "#3599B8", "#DFBFBF"
                ],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'horizontal', // horizontal for horizontal bars
                        shadeIntensity: 0.5,
                        gradientToColors: undefined, // can also set array for per-bar gradient
                        inverseColors: false,
                        opacityFrom: 0.85,
                        opacityTo: 0.85,
                        stops: [0, 100]
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#000000']
                    },
                },
                xaxis: {
                    categories: [],
                    title: { text: "Number of Students" },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} students`
                    }
                },
                legend: {
                    show: true,
                    position: "right",
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[0][opts.seriesIndex];
                    }
                },
                responsive: [
                    {
                        breakpoint: 1024,
                        options: {
                            legend: {
                                position: 'bottom',
                            }
                        }
                    },
                    {
                        breakpoint: 640,
                        options: {
                            legend: {
                                show: false,
                            }
                        }
                    },
                ],
            }
        };
    },
    computed: {
        hasData() {
            return this.series.length && this.series[0].data.length;
        }
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData) || newData.length === 0) {
                    this.series = [];
                    this.chartOptions = {
                        ...this.chartOptions,
                        xaxis: { ...this.chartOptions.xaxis, categories: [] }
                    };
                    return;
                }

                const categories = [];
                const counts = [];

                for (const { label, count } of newData) {
                    categories.push(label);
                    counts.push(count);
                }

                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: { ...this.chartOptions.xaxis, categories }
                };

                this.series = [{ name: "Students", data: counts }];
            },
            immediate: true
        }
    },
};
</script>